"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.forkError = exports.verifyResponse = exports.attemptNoContent = exports.attemptPromotionBody = exports.safeAttemptBody = exports.attemptBody = void 0;
const fluture_1 = require("fluture");
/**
* Attempt to parse the response's body into json
*/
const attemptBody = (response) => (0, fluture_1.attemptP)(() => response.json());
exports.attemptBody = attemptBody;
/**
* Attempt to parse the response's body as json and return null if it fails
*/
const safeAttemptBody = (response) => (0, fluture_1.attemptP)(() => response.json().catch(() => null));
exports.safeAttemptBody = safeAttemptBody;
/**
 * Attempt to parse the Promotion API response body, conditionally
 * handling the 204 response as a null value for Redux cache clears
 */
const attemptPromotionBody = (response) => (0, fluture_1.attemptP)(() => response.status === 204 ? Promise.resolve(null) : response.json());
exports.attemptPromotionBody = attemptPromotionBody;
/**
 * Attempt to parse a 204 no content API response body
 */
const attemptNoContent = (response) => (0, fluture_1.attemptP)(() => response.status === 204 ? Promise.resolve(null) : response.json());
exports.attemptNoContent = attemptNoContent;
/**
 * Verify that the response is OK (200 code)
 */
exports.verifyResponse = (0, fluture_1.chain)((response) => response.ok
    ? (0, fluture_1.resolve)(response)
    : (0, fluture_1.attemptP)(() => response.text())
        .pipe((0, fluture_1.chain)(res => {
        const err = Error(`${response.status}: ${res} - ${response.url}`);
        /**
         * Mutating these keys is the only way to do this
         * since we're using extending the built in Error object.
         */
        // eslint-disable-next-line functional/immutable-data
        err.status = response.status;
        // eslint-disable-next-line functional/immutable-data
        err.statusText = response.statusText;
        return (0, fluture_1.reject)(err);
    })));
/**
 * Used after attempting to get the error body with attemptBody.
 * We want to call the same handle failure on success or failure.
 */
const forkError = (handleFailure) => (0, fluture_1.fork)(handleFailure)(handleFailure);
exports.forkError = forkError;
//# sourceMappingURL=fluture-utils.js.map